import React, {useState, useEffect} from "react";
import AddNewButton from "../Buttons/AddNewButton";
import ViewButton from "../Buttons/ViewButton";
import FilterButton from "../Buttons/FilterButton";
import { db } from "../../firebase";
import {equalTo, onValue, ref, set, query, orderByChild, orderByValue, get, child, remove} from 'firebase/database';


const BinTable = (props  ) => {
    const [isLoading, setIsLoading] = useState(true)

    const [bins, setBins] = useState([]);

    useEffect(() => {
        const fetchBins = async () => {
        try {
            const binRefrence = await ref(db, 'bins');
            onValue(binRefrence, snapshot =>{
                if ((snapshot).exists) {
                const binsData = (snapshot).val();
                const binsArray = Object.entries(binsData).map(([binId, bin]) => ({
                    id: binId,
                    ...bin,
                }));
                setBins(binsArray.reverse());
                setIsLoading(false)
                }
            })
        } catch (error) {
            console.error('Error retrieving bins:', error);
        }
        };

        fetchBins();
    }, []);
    
    const delBins = async (id) =>{
        console.log(id);
        const binRefrence = await ref(db, 'bins');
        const childRef = child(binRefrence, id);
        await remove(childRef);
        console.log(`child ${childRef} is removed`)
    }



    return (
        <div className="max-w-screen-xl px-4 mx-auto">
            <div className="flex items-center justify-between mb-4 binhead gap-x-10">
                <h3 className="mb-2 text-4xl font-bold tracking-tight text-gray-900 dark:text-white">Bins</h3>
                {/* <div className="flex-1">
                    <ViewButton innerTxt={"View On Map"}/>
                </div> */}
                {/* <div className="">
                    <FilterButton innerTxt={"Filter"}/>
                </div> */}
            </div>
    
            <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 border-collapse" >
                    <thead class="text-s text-gray-700  bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sm:rounded-xl border-collapse: separate">
                        <tr className="sm:rounded-xl">
                            <th scope="col" class="px-6 py-3">
                                BinId#
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Resident/Org
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Status
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Filled
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Location
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Last Updated
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <span class="sr-only">Del</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <>
                            {isLoading ? <tr class="bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                <td scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">Loading...</td>
                            </tr>
                            :
                            <>
                                {bins ? bins.map((bin) => (
                                    <tr class="bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={bin.id}>
                                    <td scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{bin.id}</td>
                                    <td class="px-6 py-4">{bin.ownerName}</td>
                                    <td class="px-6 py-4">{bin.status}</td>
                                    <td class="px-6 py-4">{bin.capacity} %</td>
                                    <td class="px-6 py-4">{bin.location}</td>
                                    <td class="px-6 py-4">{bin.lastUpdated ? bin.lastUpdated: 'none'}</td>
                                    <td class="px-6 py-4 text-right">
                                        <a href="" onClick={(e)=>{
                                            e.preventDefault();
                                            const id = bin.id;
                                            delBins(id);
                                        }} class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Del</a>
                                    </td>
                                    {/* Add more table cells for additional bin properties */}
                                    </tr>
                                ))
                                :
                                <tr class="bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                    <td scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">No Bins Available</td>
                                </tr>
                                }
                            </>
                            }
                        </>
                        
                        
                    </tbody>
                </table>
            </div>


        </div>
    )
}

export default BinTable